/**
 * Property Communications tab — info-popover tooltip content (JSX).
 * Kept in a `.tsx` sibling of `constants/index.ts` (JSX can't live in the `.ts` barrel);
 * re-exported through `../constants`.
 */

export const TOOLTIP_REPORTS_FREQUENCY = (
  <p className="m-0">
    <span className="font-medium text-slate-900">Note: </span>
    Reports are available on Fridays. Monthly on the last Thursday of the month to show the past month&apos;s
    performance. Weekly to see performance for the week.
  </p>
)
